/**
 * Origen del embed. El checkout web manda `?source=desktop`.
 * La app nativa no manda el parámetro y sigue en el maquetado actual.
 */
export type EmbedSource = 'app' | 'desktop';

export function readEmbedSource(search: string): EmbedSource {
  const source = new URLSearchParams(search).get('source');
  return source === 'desktop' ? 'desktop' : 'app';
}

/** Viewport del checkout web. Lo manda el host: el iframe no puede medirlo. */
export type HostViewport = 'desktop' | 'mobile';

export function readHostViewport(search: string): HostViewport | null {
  const layout = new URLSearchParams(search).get('layout');
  if (layout === 'mobile' || layout === 'desktop') return layout;
  return null;
}
